module.exports = __webpack_public_path__ + "static/media/cloud-sketches.2d6fdc2c.svg";